<template>
  <div class="main-container" :class="mainClasses" v-if="is_ready">
    <notification />
    <modals />
    <layout v-if="layout == 'classic'" @logout="logout" />
    <fluid-layout v-else-if="layout == 'fluid'" @logout="logout" />
    <public-layout v-else-if="layout == 'public'" @login="login" />
    <dashboard-layout v-else-if="layout == 'dashboard'" @login="login" />
    <empty-layout v-else-if="layout == 'empty'" />
  </div>
</template>

<script>
import Session from "@/classes/Session";
import Layout from "@/components/layouts/Layout";
import FluidLayout from "@/components/layouts/FluidLayout";
import PublicLayout from "@/components/layouts/PublicLayout";
import DashboardLayout from "@/components/layouts/DashboardLayout";
import Configuration from "@/classes/Configuration";
import EmptyLayout from "@/components/layouts/EmptyLayout";
import Notification from "@/components/helpers/DataDisplay/Notification";
import Modals from "@/components/layouts/partials/Modals";

export default {
  name: "app",
  metaInfo() {
    return {
      title: "Admin",
      titleTemplate: `%s | ${this.favIcoAndTitle["title"]}`
    };
  },
  components: {
    Layout,
    PublicLayout,
    FluidLayout,
    EmptyLayout,
    Modals,
    DashboardLayout,
    Notification
  },
  mounted() {
    this.setLayout();
    this.setUserLocaleByPlan(this.currentPlanIsTalent);
    this.setFavIcoAndTitle();
    Session.init();
    this.is_ready = true;
    this.userInit();
  },
  data() {
    return {
      is_ready: false,
      layout: ""
    };
  },
  computed: {
    favIcoAndTitle() {
      return this.$store.getters.getFavIcoAndTitle;
    },
    current_user() {
      return this.$store.getters.currentUser;
    },
    intercomSettingsHash() {
      return this.$store.getters.getIntercomSettings;
    },
    intercomInitialized() {
      return this.$store.getters.getIntercomInitialized;
    },
    mainClasses() {
      return this.$store.getters.getMainContainerClasses;
    },
    currentPlanIsTalent() {
      return this.$store.getters.getCurrentPlanIsTalent;
    }
  },
  methods: {
    setFavIcoAndTitle() {
      var link =
        document.querySelector("link[rel*='icon']") ||
        document.createElement("link");
      link.type = "image/x-icon";
      link.rel = "shortcut icon";
      link.href = this.favIcoAndTitle["ico"];
      document.getElementsByTagName("head")[0].appendChild(link);
    },
    hideIntercom() {
      window.Intercom("shutdown");
    },
    initIntercom() {
      if (!this.intercomSettingsHash) {
        return;
      }
      if (!this.intercomInitialized) {
        window.Intercom("boot", this.intercomSettingsHash);
        this.$store.commit("SET_INTERCOM_INITIALIZED", true);
      } else {
        window.Intercom("update", this.intercomSettingsHash);
      }
    },
    login() {
      if (this.current_user) {
        this.layout = "classic";
      } else {
        this.layout = "public";
      }
    },
    logout() {
      window.Intercom("shutdown");
      if (this.current_user) {
        this.layout = "classic";
      } else {
        this.layout = "public";
      }
    },
    userInit() {
      // Just for having the '/login' in url if not connected
      if (!this.current_user && this.layout !== "public") {
        this.$router.push("/login");
        location.reload();
      }
      // Unallow logged in users to view public pages
      if (this.current_user && this.layout == "public") {
        this.layout = "classic";
        this.$router.push("/");
      }
    },
    setLanguage(locale) {
      this.$store.commit("CHANGE_LANGUAGE", locale);
    },
    // If the users current plan is talent we need to use specific language files
    // If user has talent language in cookies but plan is not talent we need to fix the locale
    async setUserLocaleByPlan(planIsTalent) {
      let currentLocale = await cookie.get("language");
      let locale = currentLocale ? currentLocale : "de";
      let localeIsTalent = locale.includes("-tal");

      // If current plan is talent but locale is not we force it
      if (planIsTalent && !localeIsTalent) {
        locale = `${locale}-tal`;
      } else if (!planIsTalent && localeIsTalent) {
        // If current plan is not talent but locale is we force it
        locale = "de";
      }

      this.setLanguage(locale);
    },
    setLayout() {
      let layout = this.$route.meta.layout;
      if (layout) {
        this.layout = layout;
      } else {
        this.layout = "classic";
      }
    }
  },
  watch: {
    $route() {
      this.setLayout();
    },
    current_user(value) {
      if (value && !this.currentPlanIsTalent) {
        this.initIntercom();
      } else {
        this.hideIntercom();
      }
    },
    currentPlanIsTalent(value) {
      if (typeof value === "boolean") {
        this.setUserLocaleByPlan(value);
      }
    }
  }
};
</script>
<style lang="scss">
html {
  font-size: 16px;
}
body {
  font-family: $font-family !important;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  font-size: 16px;
  font-weight: $font-regular;
  color: $ink-dark;
}

.q-layout {
  display: flex;
  flex-direction: column;
}

.q-loading-bar,
.bg-red {
  background-color: $sensual !important;
}
.q-loading-bar.top {
  background-color: $sensual !important;
}
.navigation-dropdown {
  .q-tab {
    background-color: $ink-dark;
  }
}

.sortable--element-edit-form {
  height: 100vh;
}

#navigation {
  .q-tabs-bar {
    border: 0;
  }
  .q-tabs-head {
    position: static;
  }

  @media (max-width: 991px) {
    .q-tabs-head:not(.scrollable) .q-tabs-scroller,
    .q-tabs-head:not(.scrollable) .q-tab {
      flex: 0 0 auto;
    }
  }
}
.navigation-dropdown {
  background: $ink-dark;
}
.dropdown,
.q-layout-drawer {
  .q-tabs-scroller {
    flex-direction: column;
    width: 100%;
  }
  .q-tab {
    background: $ink-dark;
  }
  .q-tabs-bar {
    border: 0;
  }
}

.q-layout-drawer {
  .q-tabs-scroller {
    width: 100%;
  }
}

.locked {
  height: 100vh;
  width: 100vw;
  overflow: hidden;
}
.intercom-namespace {
  z-index: 25 !important;
}

.hidden {
  display: none !important;
}

.optional {
  display: none !important;
}

span.vdp-datepicker__clear-button {
  position: absolute;
  top: 15px;
  right: 40px;
  font-size: 1.5em;
  color: $ink-lighter;
  transition: all 0.15s ease-out;
  &:hover {
    color: $ink;
  }
  i {
    font-style: normal;
  }
}

.router-view {
  margin: 0 auto;
}

@media (min-width: 576px) {
  .router-view {
    max-width: 576px;
    width: 576px;
  }
}

@media (min-width: 768px) {
  .router-view {
    max-width: 768px;
    width: 768px;
  }
}
@media (min-width: 992px) {
  .router-view {
    max-width: 992px;
    width: 992px;
  }
}
@media (min-width: 1200px) {
  .router-view {
    max-width: 1200px;
    width: 1200px;
  }
}
@media (min-width: 1360px) {
  .router-view {
    max-width: 1360px;
    width: 1360px;
  }
}
.q-layout-page-container {
  padding-top: 0px !important;
}

</style>



// WEBPACK FOOTER //
// App.vue?15e8ce2a